import { FontSizeTokens, FontDecorationToken, FontTransformToken, EllipsizeModeTokens, TextAlignTokens, FontFamilyTokens, TypographyTypeTokens, } from '@voltmoney/schema';
export const args = {
    label: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.fewfefewfewfbejkbfhebfhbefbewjhfvjwevfeg qjhvwvevgw wqgvdwvwq',
    type: TypographyTypeTokens.DEFAULT,
    textAlign: TextAlignTokens.auto,
    textTransform: FontTransformToken.none,
    textDecorationLine: FontDecorationToken.none,
    numberOfLines: 0,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(TypographyTypeTokens),
        ],
    },
    ellipsizeMode: {
        control: 'select',
        options: [
            ...Object.values(EllipsizeModeTokens),
        ],
    },
    fontSize: {
        control: 'select',
        options: [
            ...Object.values(FontSizeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    fontFamily: {
        control: 'select',
        options: [...Object.values(FontFamilyTokens)],
    },
    textAlign: {
        control: 'select',
        options: [...Object.values(TextAlignTokens)],
    },
    textTransform: {
        control: 'select',
        options: [...Object.values(FontTransformToken)],
    },
    textDecorationLine: {
        control: 'select',
        options: [
            ...Object.values(FontDecorationToken),
        ],
    },
};
